import request from '@/utils/request'

// 获取财务报表数据
export function getFinancialReport(params) {
  return request({
    url: '/admin.getFinancialReport',
    method: 'get',
    params
  })
}
